import { UserProfile } from "@domain/types";
import { AuthContextProps } from "oidc-react/build/src/AuthContextInterface";

export function getUser(auth: AuthContextProps): UserProfile | null | undefined {
  return auth.userData?.profile as unknown as UserProfile;
}
